import { render, staticRenderFns } from "./width.vue?vue&type=template&id=20f47c9e&scoped=true&"
import script from "./width.vue?vue&type=script&lang=js&"
export * from "./width.vue?vue&type=script&lang=js&"
import style0 from "./width.vue?vue&type=style&index=0&id=20f47c9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f47c9e",
  null
  
)

export default component.exports